import { useInstance } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
export function useActiveValue() {
  var instance = useInstance();
  var activeValue = useState(0);
  instance.on('$receive:value', function (v) {
    if (!instance.get('half')) v = Math.round(v);
    instance.set('value', v);
    activeValue.set(v);
  });
  function onClick(value) {
    if (instance.get('disabled')) return;
    // clear the value when click again on the clearable component
    if (instance.get('clearable') && instance.get('value') === value) {
      value = 0;
    }
    instance.set('value', value);
    activeValue.set(value);
  }
  function onMouseEnter(value) {
    if (instance.get('disabled')) return;
    activeValue.set(value);
  }
  function onMouseLeaveComponent(e) {
    instance.trigger('mouseleave', e);
    if (instance.get('disabled')) return;
    activeValue.set(instance.get('value'));
  }
  return {
    activeValue: activeValue,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeaveComponent: onMouseLeaveComponent
  };
}